import { createSelector } from 'reselect';
import { createModuleStateSelector } from '@americanexpress/travel-selectors';
import { ROOT_MODULE_NAME } from '../constants/packagesConstants';

const getRootModuleState = createModuleStateSelector(ROOT_MODULE_NAME);

export const getIsSearchSubmitting = createSelector(
  getRootModuleState,
  (state) => state.getIn(['search', 'isSubmitting'])
);
